module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_is-object.js
// module id = 1363
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 13 14 15 16